import { z } from "zod";

const translationPath =
  "chatBot.page.register.ticketServiceWhats.whatsappProfilePath.";

const genericSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const whatsappProfileSchema = z.object({
  about: z.string().optional().nullish(),
  address: z.string().optional().nullish(),
  description: z.string().optional().nullish(),
  email: z.string().optional().nullish(),
  profilePictureUrl: z.string().optional().nullish(),
  websites: z.array(z.string()).optional().nullish(),
  vertical: genericSchema.nullish(),
  messagingProduct: z.string().optional(),
  file: z
    .instanceof(File, { message: translationPath + "file" })
    .refine((val) => val, translationPath + "file")
    .optional(),
});

export type TWhatsappProfileForm = z.infer<typeof whatsappProfileSchema>;
